"use strict";

import BaseModel from "@/shared/lib/client-sdk/base-model";

class EntityFlag extends BaseModel {
  constructor(idOrAttributes, onRefreshCallback = null) {
    super(idOrAttributes, onRefreshCallback);
  }

  static getModelClassName() {
    return "EntityFlag";
  }

  static getApiPathForSearch() {
    return (
      window.amplifyRuntimeConfig.get("VUE_APP_API_BASE_URL") + "/private/flags"
    );
  }

  getApiPathForCreate() {
    console.error("Cannot create flag directly, must be created on an entity.");
  }

  getApiPathForRefreshUpdateAndDelete() {
    console.error("Cannot update flag directly, must be updated on an entity.");
  }

  getAdminPath() {
    console.error("Cannot go to an entity flag.");
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultTitle() {
    return this.flagName;
  }

  // Returns a string, or an array of strings (for a multi-line)
  get searchResultSubtitle() {
    return null;
  }

  get searchResultCreatedAt() {
    return null;
  }

  get searchResultStatus() {
    return null;
  }
}

export default EntityFlag;
